import { IFillTemplate, IFillTemplateResult } from 'CommonTypes/DocsTemplates/IFillTemplate';
import { nodePath } from 'Config/path.js';
import { fetchPost } from 'Services/fetchService.js';

export default async (data: IFillTemplate) => {
    const response: IFillTemplateResult = await fetchPost(`${nodePath}/docs-templates/doc/${data.outboxId}-${data.templateId}`);
    return response;
};
